import { createAsyncSliceWithDataAndQuery } from '../../createAsyncSliceWithDataAndQuery';
import { getEscrowBalancesForOrderId } from '../../../API/order/escrow/getEscrowBalancesForOrderId';
import { IEscrowBalancesData } from '../../../types/order/escrow/data/IEscrowBalancesData';

export const { slice: escrowBalancesHeaderSlice, asyncAction: loadEscrowBalancesAsync } =
  createAsyncSliceWithDataAndQuery('escrowBalancesHeaderSlice', getEscrowBalancesForOrderId, {} as IEscrowBalancesData);
